import MessageModal from "../Modal/v2/Message";

export default function Warning({ warnings, closeModal }) {
  return (
    <>
      <MessageModal
        open={true}
        closeModal={closeModal}
        heading={"Warning"}
        messages={warnings}
      />
    </>
  );
}
